import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dBoxBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-Icon3dBoxBottom"><Path d="M11.25 11.5674V1.31738L2.37305 6.44238V16.6924L11.25 11.5674Z" fill="currentColor"/><Path d="M21.627 6.44238L12.75 1.31738V11.5674L21.627 16.6924V6.44238Z" fill="currentColor"/><Path d="M20.876 17.9912L12 12.8662L3.12305 17.9912L12 23.1162L20.876 17.9912Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon3dBoxBottom;
